"use strict";

angular.module("casist.ucto").factory("PokladnicnyDoklad", [
  "Restangular",
  "$q",
  "BaseModel",
  "BaseCollectionModel",
  "Profile",
  "$modal",
  "DokladCommon",
  "$translate",
  "$timeout",
  "Upload",
  "$http",
  function (
    Restangular,
    $q,
    BaseModel,
    BaseCollectionModel,
    Profile,
    $modal,
    DokladCommon,
    $translate,
    $timeout,
    Upload,
    $http
  ) {
    var ENDPOINT = "pokladna";
    Restangular.extendModel(ENDPOINT, function (model) {
      angular.extend(model, BaseModel);
      angular.extend(model, DokladCommon);
      angular.extend(model, {
        countEditableSums: function (evt) {
          var self = this;
          $timeout(function () {
            DokladCommon.countEditableSums.call(self, evt);
            var pokladne = _.filter(angular.copy(Profile.get("pokladne")), {
              active: true,
            });
            var pokladna = _.find(pokladne, { id: parseInt(self.pokladna) });
            if (pokladna.typ === 2) {
              self.hotovost = self.spolu;
            }
          });
        },
        getCenaFields: function () {
          var mnozstvoField = this.operacia === 1 ? "mv" : "mp";
          var cenaField = this.operacia === 1 ? "cena_vydaj" : "cena_prijem";
          return { cena: cenaField, mnozstvo: mnozstvoField };
        },
      });
      return angular.extend(model, {
        validate: function () {
          BaseModel.validate();
          var result = true;
          if (!angular.isDefined(this.d_vyst) || this.d_vyst === "") {
            this.addError("d_vyst", "Pole nemôže byť prázdne");
            result = false;
          }
          if (!this.d_zdp) {
            this.addError("d_zdp", "Pole nemôže byť prázdne");
            result = false;
          }
          if (!this.pokladna) {
            this.addError("pokladna", "Pole nemôže byť prázdne");
            result = false;
          }
          //if (!this.firma) {
          //  this.addError('firma', $translate.instant('errors.FIRMA'));
          //  result = false;
          //}
          if (this.vs && !/^[0-9]*$/.test(this.vs)) {
            this.addError("vs", "Variabilný symbol musí obsahovať iba čísla!");
            result = false;
          }
          return result;
        },
      });
    });

    var openDetail = function (item, list, SearchCtrl, config) {
      var modalInstance = $modal.open({
        templateUrl: "ucto/pokladnicnedoklady/pokladnicnedoklady-detail.html",
        controller: "PokladnicnyDokladDetailCtrl",
        backdrop: "static",
        keyboard: false,
        windowClass: "detail",
        resolve: {
          doklad: function () {
            return item ? item : {};
          },
          list: function () {
            return list || [];
          },
          SearchCtrl: function () {
            return SearchCtrl;
          },
          config: function () {
            return angular.extend({ predkontacie: true, ucty: true }, config);
          },
        },
      });
      return modalInstance.result;
    };
    var parent = BaseCollectionModel.object(ENDPOINT);
    return angular.extend(parent, {
      getPerms: function () {
        return Profile.get("perms").pokladnicnydoklad;
      },
      parovanie: function () {
        return Restangular.all("pokladna").all("parovanie");
      },
      getUctoFields: function () {
        return [
          "zaklad_d1",
          "d1",
          "zaklad_d2",
          "d2",
          "zaklad_d0",
          "spolu",
          "suma1",
          "suma2",
          "suma3",
          "suma4",
          "suma5",
        ];
      },
      globalneUctovanie: function (predkontacia, query, canceller) {
        if (canceller) {
          return Restangular.all("pokladna")
            .withHttpConfig({ timeout: canceller })
            .customPUT(
              { predkontacia: predkontacia },
              "globalneuctovanie",
              query
            );
        } else {
          return Restangular.all("pokladna").customPUT(
            { predkontacia: predkontacia },
            "globalneuctovanie",
            query
          );
        }
      },
      edit: function (doklad, list, searchCtrl, config) {
        var promise = $q.defer();
        if (doklad) {
          parent.restangularize(doklad);
        }
        openDetail(doklad, list, searchCtrl, config).then(
          function (data) {
            promise.resolve(data.record);
          },
          function () {
            promise.reject();
          }
        );
        return promise.promise;
      },

      uploadAttachment: function (file, doklad) {
        Upload.upload({
          url: Restangular.all(ENDPOINT).all('attachment').getRestangularUrl(),
          data: { dokladId: doklad.id },
          file: file,
          headers: {
            Authorization: $http.defaults.headers.common.Authorization,
            'X-Agenda': $http.defaults.headers.common['X-Agenda'],
          },
        })
        .then(
          function (response) {
            doklad.attachment = response.data.filename;
          },
          function (error) {
            Dialog.alert('Formát súboru nie je podporovaný.', 'Chyba');
            console.log(error);
          }
        );

      },

      removeAttachment: function (doklad) {
        Upload.upload({
          method: 'delete',
          url: Restangular.all(ENDPOINT).all('attachment').getRestangularUrl(),
          data: { dokladId: doklad.id },
          headers: {
            Authorization: $http.defaults.headers.common.Authorization,
            'X-Agenda': $http.defaults.headers.common['X-Agenda'],
          },
        })
        .then(
          function (response) {
            doklad.attachment = '';
          },
          function (error) {
            console.log(error);
          }
        );
      },
      precislovanieDokladov: function (filter) {
        return Restangular.all(ENDPOINT).all('precislovanie-dokladov').post(filter);
      },
    });
  },
]);
